/* eslint-disable */
import React from 'react';

import IconMenu from 'material-ui/IconMenu';
import Divider from 'material-ui/Divider';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

import ArrowIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-right';
import ViewIcon from 'material-ui/svg-icons/image/remove-red-eye';
import RateIcon from 'material-ui/svg-icons/action/stars';
import MarkReadIcon from 'material-ui/svg-icons/navigation/check';
import MarkUnReadIcon from 'material-ui/svg-icons/av/not-interested';
import CommentIcon from 'material-ui/svg-icons/communication/comment';

class ContentItemAction extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      open: false
    };
    this.item = props.children.props.item;
    this.viewItem = this.viewItem.bind(this);
    this.markItemReadItem = this.markItemReadItem.bind(this);

  }

  viewItem(){
    // handle view item by type
    switch (this.item.type) {
      case "material-to-read": case "video": case "blog": case "book":
        window.open(this.item.url,'_blank');
        break;
      default:
        // or do nothing
        console.warn('type not recognised');
    }
  }

  markItemReadItem(){
    // this is when we need to use REDUX!
    //console.log('MARK AS READ - REDUX TIME');
  }

  render() {
    const viewItem = this.viewItem;
    const style = {
      mainItem: {
        width: "100%"
      },
      markRead: {
        color: "green"
      }
    };

    return (
      <div>
        <div>
          <IconMenu
            iconButtonElement={this.props.children}
            anchorOrigin={{horizontal: 'right', vertical: 'top'}}
            targetOrigin={{horizontal: 'right', vertical: 'top'}}
            style={style.mainItem}
          >
            <MenuItem
              primaryText="View"
              leftIcon={<ViewIcon/>}
              onTouchTap={viewItem}/>
            <Divider />
            <MenuItem
              primaryText="Rate"
              leftIcon={<RateIcon/>}
            />
          {this.item.read &&
            <MenuItem
              primaryText="Mark As Unread"
              leftIcon={<MarkUnReadIcon/>}
            />
          }
          {!this.item.read &&
            <MenuItem
              primaryText="Mark As Read"
              leftIcon={<MarkReadIcon color={style.markRead.color}/>}
            />
          }
            <MenuItem
              primaryText="Comments"
              leftIcon={<CommentIcon/>}
            />
          </IconMenu>
        </div>
      </div>
    );
  }
}

export default ContentItemAction;



/** WEBPACK FOOTER **
 ** ./src/components/common/content-items/ContentItemAction.js
 **/